import React, { memo, useEffect, useState } from 'react';
import BetslipOverlay from './BetslipLoadable';
import { useReframe } from 'nike-re-framejs';
import { isRegistrationRoute } from '@/routing/routeutils';
import { cashinClosingModeAnyActive$ } from 'nike-ui/src/components/ticketus/subs';
import { LOCAL_STORAGE_TICKETS_DAILY_LIMIT } from 'nike-ui/src/components/tournaments/constants';
import moment from 'moment';
import PopupNg from '@/ui/PopupNg';
import { tournament$$, tournamentsActive$ } from '@/tournaments/subs';
import { registerPopup } from '@/ui/popupRegistrar';
import TournamentDailyLimitDialog from '@/tournaments/components/tournament-daily-limit-dialog/TournamentDailyLimitDialog';
import { getTicketsCount } from '@/betslip/utils';

registerPopup('Tournaments/DailyLimitDialog', popup => <TournamentDailyLimitDialog {...popup.get('data')} />);

function BetslipRoot({ ticketEditorOpened, route }) {
    /** Cela funkcionalita s useEffectami musi byt v tomto komponente
     * aj ked vhodnejsie miesto by bolo Betslip.js, ale ten sa renderuje
     * iba ak nejde o rychle podanie tiketu, cize tam by sme toto museli
     * copy-pastnut takisto.
     **/

    const { derefSub, subscribe } = useReframe();
    const id = subscribe(tournamentsActive$);
    const tournament = id && subscribe(tournament$$(id[0]));
    const date = moment().format('YYYY-MM-DD');
    const [ticketsCount, setTicketsCount] = useState({});
    const modalDisplayedDate = localStorage.getItem(LOCAL_STORAGE_TICKETS_DAILY_LIMIT);
    const betIsSubmitted = derefSub(['betslip/isSubmitted']);

    const now = moment();
    const end = tournament && moment(tournament.end);
    const lastTournamentDay = now.isSame(end, 'day');
    const modalAlreadyDisplayedToday = modalDisplayedDate && now.isSame(modalDisplayedDate, 'day');

    useEffect(() => {
        if (modalDisplayedDate && !modalAlreadyDisplayedToday) {
            localStorage.removeItem(LOCAL_STORAGE_TICKETS_DAILY_LIMIT);
        }
    }, [modalDisplayedDate, modalAlreadyDisplayedToday]);

    useEffect(() => {
        if (date && id?.length && betIsSubmitted) {
            getTicketsCount(id[0], date).then(res => setTicketsCount(res));
        }
    }, [date, id, betIsSubmitted]);

    useEffect(() => {
        if (!modalAlreadyDisplayedToday && ticketsCount?.maxTickets && betIsSubmitted) {
            if (ticketsCount?.ticketCount === ticketsCount.maxTickets) {
                PopupNg.dispatcher.open('Tournaments/DailyLimitDialog', { lastTournamentDay });
            }
        }
    }, [ticketsCount, betIsSubmitted, lastTournamentDay, modalAlreadyDisplayedToday]);

    if (isRegistrationRoute(route)) {
        return null;
    }
    const cashinClosingModeActive = subscribe(cashinClosingModeAnyActive$);

    return !cashinClosingModeActive && ticketEditorOpened ? <BetslipOverlay /> : null;
}

export default memo(BetslipRoot);
